export const GET_ACTIVATION_REPORT = "GET_ACTIVATION_REPORT";
export const GET_ACTIVATION_REPORT_SUCCESSFULL = "GET_ACTIVATION_REPORT_SUCCESSFULL";
export const GET_ACTIVATION_REPORT_FAILED = "GET_ACTIVATION_REPORT_FAILED";
export const RESET_VALIDATION_REPORT = "RESET_VALIDATION_REPORT";
